import { IDataSource } from "../../../../Data/DataSource";
import { PartialNullable } from "../../../../Extensions";
import { PropertyChange } from "../../../../PropertyChange";
import { Property, PropertyBoolean, PropertyObject, RadObjectConstructor } from "../../../../RadObject";
import { IControl } from "../../../../Ui/Controls/Control";
import { Class } from "../../System/Class";
import { EvaluatorPropertyValues, IEvaluator } from "./IEvaluator";
import { NAMESPACE } from "./_Namespace";

const
    registeredEvaluators: { classConstructor: RadObjectConstructor<Evaluator>, dataType: string }[] = [];

export abstract class Evaluator<TPropertyValues extends EvaluatorPropertyValues = EvaluatorPropertyValues> extends Class<TPropertyValues> implements IEvaluator
{
    // #region Static

    public static override classNamespace = NAMESPACE + "Evaluator";
    public static override className = "Evaluator";

    // #endregion

    // #region Instance

    // #region Properties

    public context!: Property<IControl | IDataSource>;
    public state!: PropertyObject;
    public value!: PropertyBoolean;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<TPropertyValues>)
    {
        super(propertyValues);

        // Trigger Property Changes
        this.value.triggerChange();
    }

    // #endregion

    // #region Public Methods

    public clone()
    {
        const
            constructor = this.constructor as RadObjectConstructor;

        return new constructor() as this;
    }
    public abstract evaluate(): boolean;
    public flatten(): IEvaluator[]
    {
        return [this];
    }

    // #endregion

    // #region Protected Methods

    protected _contextChanged(change: PropertyChange<IControl | IDataSource>)
    {
        this.evaluate();
    }
    protected _stateChanged(change: PropertyChange<any>)
    {
        this.evaluate();
    }
    protected _valueChanged(change: PropertyChange<boolean>)
    {
        this.triggerHandler("valueChanged", change);
    }

    // #endregion

    // #region Overrides

    protected override __initializeProperties(propertyValues: EvaluatorPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this.context = new Property<IControl | IDataSource>(this, "System.Object, System.Private.CoreLib", propertyValues.context, this._contextChanged);
        this.state = new PropertyObject(this, propertyValues.state, this._stateChanged);
        this.value = new PropertyBoolean(this, propertyValues.value, this._valueChanged);
    }

    // #endregion

    // #endregion
}
